import { getRouterSelectors, RouterReducerState } from '@ngrx/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CoreState } from './core.state';
import { AppState } from '..';

/**
 * Built-in ngrx router-store selectors
 */
const selectRouter = createFeatureSelector<RouterReducerState>('router');
export const {
  selectCurrentRoute, // select the current route
  selectRouteParams, // select the current route params
  selectUrl, // select the current url
} = getRouterSelectors(selectRouter);

const coreState = (state: AppState) => state.core;

export const selectShowLoader = createSelector(coreState, (state: CoreState) => state.showLoader);
export const selectShowPopinLoader = createSelector(coreState, (state: CoreState) => state?.showPopinLoader);
export const selectLoaderTransparent = createSelector(coreState, (state: CoreState) => state.loaderTransparent);
/**
 * Selector for show progress bar
 * always returns false if loader or deprecated loader are visible
 */
export const selectShowProgressBar = createSelector(
  coreState,
  selectShowLoader,
  (state: CoreState, showLoader: boolean) => !showLoader && state.showProgressBar,
);

/**
 * Select available bcs pdf languages
 */
export const selectBCSLanguages = createSelector(coreState, (state: CoreState) => state.localization?.bcsLanguages);

/**
 * Select tool information
 */
export const selectToolInfo = createSelector(coreState, (state) => ({
  tool: state?.tool,
  prevTool: state?.prevTool,
  tool_flow_id: state?.tool_flow_id,
}));

/**
 * Select breeds
 */
export const selectBreeds = createSelector(coreState, (state) => state.breeds);
/**
 * Select alerts
 */
export const selectAlerts = createSelector(coreState, (state) =>
  // filter out duplicates
  state.alerts.filter(
    (alert, index, alerts) => index === alerts.findIndex((al) => al.message === alert.message && al.alertType === alert.alertType),
  ),
);

export const selectStepperItems = createSelector(coreState, (state) => state.stepperItemsPerTool[state.tool]);
export const selectStepperItemsLegacy = createSelector(coreState, (state) => state.stepperItemsPerToolLegacy[state.tool]);
/**
 * Select toasts
 */
export const selectToasts = createSelector(coreState, (state) =>
  // filter out duplicates
  state.toasts.filter((toast, index, toasts) => index === toasts.findIndex((al) => al.id === toast.id)),
);
